import { gql } from "@apollo/client";

export const CREATE_REQ_PURCHASE = gql`
  mutation CreateReqPurchase($input: ReqPurchaseInput) {
    createReqPurchase(input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const SELECT_UNIT_BYID_MATERIAL = gql`
  query SelectUnitByMaterialId($materialId: ID) {
    selectUnitByMaterialId(materialId: $materialId) {
      _id
      costPerUnit
      unitId {
        unitKhName
        unitEnName
      }
      imageSrc
    }
  }
`;

export const GET_REQ_PURCHASE_PAGINATION = gql`
  query GetReqPurchasePagination(
    $page: Int
    $limit: Int
    $no: Int
    $pagination: Boolean
    $priority: PriorityEnum
    $date: Date
    $status: ReqPurchaseStatusEnum
  ) {
    getReqPurchasePagination(
      page: $page
      limit: $limit
      no: $no
      pagination: $pagination
      priority: $priority
      date: $date
      status: $status
    ) {
      data {
        _id
        no
        needDate
        supplierId {
          _id
          name
        }
        warehouseId {
          _id
          warehouseName
        }
        requestMaterials {
          _id
          listMaterialUnitId {
            _id
            costPerUnit
            imageSrc
            materialId {
              _id
              materialKhName
              materialEnName
              sizeId {
                _id
                sizeEnName
                sizeKhName
              }
            }
            qtyInUnit
            unitId {
              _id
              unitEnName
              unitKhName
            }
          }
          qty
          unitPrice
        }
        checkMaterials {
          _id
          qty
          unitPrice
          listMaterialUnitId {
            _id
            imageSrc
            costPerUnit
            materialId {
              _id
              materialEnName
              materialKhName
              sizeId {
                _id
                sizeEnName
                sizeKhName
              }
            }
            qtyInUnit
            remark
            unitId {
              _id
              unitEnName
              unitKhName
            }
          }
        }
        purchaseMaterials {
          _id
          unitPrice
          qty
          listMaterialUnitId {
            _id
            costPerUnit
            imageSrc
            materialId {
              _id
              materialEnName
              materialKhName
            }
            qtyInUnit
            remark
            unitId {
              _id
              unitEnName
              unitKhName
            }
          }
        }
        receiveMaterials {
          _id
          listMaterialUnitId {
            _id
            costPerUnit
            imageSrc
            qtyInUnit
            unitId {
              _id
              unitKhName
              unitEnName
            }
            materialId {
              _id
              materialEnName
              materialKhName
            }
          }
          unitPrice
          qty
        }
        priority
        remark
        status
        checkBy {
          createdAt
          remark
          userId {
            _id
            mainUserId {
              _id
              email
              firstName
              lastName
              latinName
              imageSrc
            }
            role
          }
        }
        purchaseBy {
          createdAt
          remark
          userId {
            _id
            mainUserId {
              _id
              email
              firstName
              lastName
              latinName
              imageSrc
            }
            role
          }
        }
        receiveBy {
          userId {
            _id
            mainUserId {
              _id
              email
              firstName
              lastName
              latinName
              imageSrc
            }
            role
          }
          createdAt
          remark
        }
        voidBy {
          createdAt
          remark
          userId {
            _id
            mainUserId {
              _id
              email
              firstName
              lastName
              latinName
              imageSrc
            }
            role
          }
        }
        shippingFee
        finalShippingFee
        createdBy {
          _id
          mainUserId {
            _id
            email
            firstName
            lastName
            latinName
            imageSrc
          }
          role
        }
        createdAt
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_REQ_PURCHASE = gql`
  mutation UpdateReqPurchase($id: ID!, $input: ReqPurchaseInput) {
    updateReqPurchase(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const VOID_REQ_PURCHASE = gql`
  mutation VoidReqPurchase($id: ID!, $remark: String) {
    voidReqPurchase(_id: $id, remark: $remark) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_REQ_PURCHASE = gql`
  mutation DeleteReqPurchase($id: ID!) {
    deleteReqPurchase(_id: $id) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CHECK_REQ_PURCHASE = gql`
  mutation CheckReqPurchase(
    $checkMaterials: [ReqPurchMaterialInput]
    $id: ID!
    $status: ReqPurchaseStatusEnum!
    $remark: String
  ) {
    checkReqPurchase(
      checkMaterials: $checkMaterials
      _id: $id
      status: $status
      remark: $remark
    ) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CREATE_PURCHASE = gql`
  mutation StartPurchase(
    $id: ID!
    $purchaseMaterials: [ReqPurchMaterialInput]
    $remark: String
  ) {
    startPurchase(
      _id: $id
      purchaseMaterials: $purchaseMaterials
      remark: $remark
    ) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const RECIEVE_PURCHASE = gql`
  mutation ReceivePurchase(
    $id: ID!
    $warehouseId: ID!
    $finalShippingFee: Float!
    $receiveMaterials: [ReqPurchMaterialInput]
    $remark: String
    $dateTime: Date
  ) {
    receivePurchase(
      _id: $id
      warehouseId: $warehouseId
      finalShippingFee: $finalShippingFee
      receiveMaterials: $receiveMaterials
      remark: $remark
      dateTime: $dateTime
    ) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;
